import { getNumber } from '@pbk/get-number';
import { joinBy } from '@pbk/utils';
import isFinite from 'lodash/isFinite';
import memoize from 'lodash/memoize';
import { getFractionDigits } from './getFractialDigits';
const DEFAULT_FRACTION_DIGITS = 2;
const getIntlInstance = memoize((locale, maximumFractionDigits, minimumFractionDigits) => {
    const fractionDigits = getFractionDigits(minimumFractionDigits ?? DEFAULT_FRACTION_DIGITS, maximumFractionDigits ?? DEFAULT_FRACTION_DIGITS);
    return new Intl.NumberFormat(locale || 'cs-CZ', {
        style: 'decimal',
        maximumFractionDigits: fractionDigits.maximumFractionDigits,
        minimumFractionDigits: fractionDigits.minimumFractionDigits,
    });
});
export const composeNumberWithUnit = ({ value, unit = '', locale, maximumFractionDigits, minimumFractionDigits, withSpace = true, }) => {
    const isValueNullable = value === null || value === undefined;
    if (isValueNullable || !isFinite(value))
        return '';
    const finalNumber = getNumber(value);
    const intl = getIntlInstance(locale, maximumFractionDigits, minimumFractionDigits);
    const formattedValue = intl.format(finalNumber);
    const separator = withSpace ? ' ' : '';
    return joinBy([formattedValue, unit], separator);
};
